import $ from 'jquery';

const regex = /#choose-location/;
const $body = $('body');
const $reserve = $('#reservation-overlay-corporate-open');
const $close = $('#reservation-overlay-corporate-close');
const $overlay = $('.reservation-overlay-corporate');
const $select = $('.reservation-overlay-corporate__select');
const $reservationBtn = document.querySelector('.reservation-overlay-corporate__button');

function open() {
  $overlay.addClass('open');
  $body.addClass('overflow-hidden');
  $body.removeClass('mobileHidden');
  $close.parent('.c-button--reservation').toggleClass('d-none');
  $overlay.find('#choose-location').prop('selectedIndex', 0).change();
  $('.con.hide-on-desktop').removeClass('open');
  $('.header-nav.open').removeClass('open');
  $('.pop-up').hide().prev().hide();
  return false;
}

function close() {
  $overlay.removeClass('open');
  $body.removeClass('overflow-hidden');
  $reserve.focus();
  $close.parent('.c-button--reservation').toggleClass('d-none');
  $select.removeClass('reservation-overlay-corporate__select--selected');
  return false;
}

$(document).on('click tap', '#reservation-overlay-corporate-open', onPopupOpen);
$(document).on('keydown', '#reservation-overlay-corporate-open', (event) => {
  const keyCode = event.keyCode ? event.keyCode : event.which;
  if (keyCode === 13) {
    onPopupOpen(event);
  }
});

function onPopupOpen(event) {
  const href = $(event.target).attr('href');
  if (!regex.test(href)) {
    return;
  }
  event.preventDefault();
  open();
  $close.focus();
}

$(document).on('click tap', (event) => {
  if (event.target.id === 'choose-location') {
    $(event.target).toggleClass('open');
  } else {
    $select.closest('.reservation-overlay-corporate__control-wrapper.open').removeClass('open');
  }
});

$select.on('change', (e) => {
  if (e.target.value !== '') {
    $select.addClass('reservation-overlay-corporate__select--selected');
  }
});

/**
 * Redirect to property's booking page
 * @param form
 * @param bookingUrl
 */
function redirectToBookingPage(form, bookingUrl) {
  if (bookingUrl.indexOf('palmettobluff') > -1) {
    const accommodationTypelinks = document.querySelectorAll('.accommodation-type__link');
    for (const link of accommodationTypelinks) {
      link.href = link.href.replace(/\?.*/gi, '');
    }

    form.find('.open-modal').trigger('click');
    return;
  }

  form.attr('action', bookingUrl.path);
  window.location.href = bookingUrl;
}

$(document).on('keydown', '.reservation-overlay-corporate__button', (event) => {
  const keyCode = event.keyCode ? event.keyCode : event.which;

  if ($select.val() == null && keyCode === 13) {
    $select.focus();
  }

  if (keyCode === 13) {
    event.preventDefault();
    const $form = $(event.target).closest('form');
    const $property = $form.find('.reservation-overlay-corporate__select');
    event.preventDefault();
    if ($property.val() === '') {
      return;
    }
    redirectToBookingPage($form, $property.val());
  }
});

$(document).on('click tap', '.reservation-overlay-corporate__button', (event) => {
  const $form = $(event.target).closest('form');
  const $property = $form.find('.reservation-overlay-corporate__select');
  event.preventDefault();

  if ($select.val() == null) {
    $select.focus();
  }

  if ($property.val() === '') {
    return;
  }
  redirectToBookingPage($form, $property.val());
});

$(document).on('keydown', '#reservation-overlay-corporate-close', (event) => {
  const keyCode = event.keyCode ? event.keyCode : event.which;
  if (keyCode === 13) {
    event.preventDefault();
    close();
    $reserve.focus();
  }
});

$reservationBtn?.addEventListener('keydown', (e) => {
  if (e.key === 'Tab' && !e.shiftKey) {
    e.preventDefault();
    $close.focus();
  }
});

$close.on('keydown', (e) => {
  if (e.key === 'Tab' && e.shiftKey) {
    e.preventDefault();
    $reservationBtn.focus();
  }
});

$(document).on('click tap', '#reservation-overlay-corporate-close', () => close());

if (window.location.href.indexOf('reserve=1') > -1) {
  open();
  $close.focus();
}
